import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Bullet
 *
 * This component is in charge of displaying
 * a bullet
 *
 * @return {jsx}
 */

const Bullet = ({ className }) => <div className={className} />;

/**
 * PropTypes Validation
 */
const { string, bool } = PropTypes;
Bullet.propTypes = {
  className: string,
  activated: bool,
};

/**
 * Default Props
 */
Bullet.defaultProps = {
  className: '',
  activated: false,
};

export default styled(Bullet)`
  border-radius: 50%;
  height: 7px;
  width: 7px;
  margin: 0 3px;
  background-color: ${({ theme: { palette } }) => palette.primary.default};
  opacity: ${({ activated }) => (activated ? '1' : '0.4')};
  transition: opacity 0.25s ease;
`;



// WEBPACK FOOTER //
// ./src/components/Slider/Bullets/Bullet/index.js